import React, { useState } from "react";
import { Redirect } from "react-router";

// Custom Components
import Table from "@Components/Table";
import Filter from "@Components/Filter";
import { useTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { NON_WORKING_DAY_HOLIDAY_URL, URLS } from "configs/constants";

let model = [
  { id: "date", label: "Date", type: "date" },
  { id: "name", label: "Name", type: "string" },
  { id: "is_global", label: "Global", type: "boolean" },
  { id: "states", label: "State", type: "string" },
  {
    id: "type_of_attendance_absent_name",
    label: "Type of Attendance (Absent)",
    type: "string",
  },
  {
    id: "type_of_attendance_present_name",
    label: "Type of Attendance (Present)",
    type: "string",
  },
];

const actions = ["edit", "delete"];

const filterFields = [
  {
    type: "input",
    label: "Year",
    name: "year",
  },
  {
    type: "reactselect",
    label: "Global",
    name: "is_global",
    outerOptions: [
      { id: "no", name: "No" },
      { id: "yes", name: "Yes" },
    ],
  },
];

export default function GlobalNonWorkingDay() {
  const { t } = useTranslation();
  const [filterValues, setFilterValues] = useState({});
  const [hariTerabai, setHariTerabai] = useState(false);
  const [weekend, setWeekend] = useState(false);
  const [holiday, setHoliday] = useState(true);
  const [tabValue, setTabValue] = useState("holiday");

  const filterInitialValues = {
    year: "",
  };
  const pageNumberDropdown = true;

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  const handleChange = (event, newValue) => {
    let type = newValue;
    if (type === "hari_terabai") {
      setHariTerabai(true);
      setHoliday(false);
      setTabValue(type);
    } else if (type === "weekend") {
      setWeekend(true);
      setHoliday(false);
      setTabValue(type);
    } else {
      console.log(type);
    }
  };

  if (holiday) {
    return (
      <div>
        <div>
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab value="holiday" label={t("Public Holiday")} />
              <Tab value="weekend" label={t("Weekend")} />
              <Tab value="hari_terabai" label="Hari Terabai" />
            </Tabs>
          </Box>
        </div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        />
        <Table
          proxyURL={NON_WORKING_DAY_HOLIDAY_URL}
          model={model}
          filterValues={filterValues}
          actions={actions}
          noFilter
          pageNumberDropdown={pageNumberDropdown}

          
        />
      </div>
    );
  } else if (hariTerabai) {
    return <Redirect to={URLS.NON_WORKING_DAY_HARI_TERABAI} />;
  } else if (weekend) {
    return <Redirect to={URLS.NON_WORKING_DAY_WEEKEND} />;
  } else {
    console.log("no where to go.");
  }
}
